import { RichText } from '@wordpress/block-editor';
import { useContext } from "@wordpress/element";
import placeholderImageUrl from '../../../../includes/assets/img/profile-image.png';
import icons from '../../../options/icons';
import BlockContext from '../context/blockContext';

const HeaderThree = () => {
    const { attributes, setAttributes, currentData, updateDataByStyleField } = useContext(BlockContext);
    const { profileImage, firstName, lastName, designation, socialIcon } = attributes;
    return (
        <div className="cv-header">
             <div className="social-icon" >
             {
                socialIcon && socialIcon.map((item, index) => {
                    return item.link ? (
                        <a key={index} href={item.link} target="_blank" rel="noopener noreferrer">
                            <span className="icon">{icons[item.icon]}</span>
                        </a>
                    ) : (
                        <span key={index} className="icon disabled">
                            {icons[item.icon]}
                        </span>
                    );
                })
            }
            </div>
        <div className="profile-img">
            {profileImage && profileImage.url ? (
                <img src={profileImage.url} alt={profileImage.alt || 'Profile Image'} />
            ) : (
                <img src={placeholderImageUrl} alt="Placeholder" />
            )}
        </div>
        <div className="profile-info">
        <div className="bwdcv-name-wrap">
            <RichText
                tagName="span"
                className="first-name"
                value={ currentData.firstName }
                onChange={(value) => updateDataByStyleField('firstName', value)}
                placeholder='Enter first name...'
            />
            <RichText
                tagName="span"
                className="last-name"
                value={ currentData.lastName }
                onChange={(value) => updateDataByStyleField('lastName', value)}
                placeholder='Enter last name...'
            />
            </div>
            <RichText
                className="designation"
                value={ currentData.designation }
                onChange={(value) => updateDataByStyleField('designation', value)}
                placeholder='Enter designation...'
            />
           
        </div>
        </div>
    )
}

export default HeaderThree
